import { Box, Typography } from "@mui/material";
import { Link } from "./Footer";

type FooterLinksProps = {
  page: any;
  index: number;
};

const Footerlinks = ({ page, index }: FooterLinksProps) => {
  return (
    <Box marginBottom={2}>
      <Typography variant="h3" marginBottom={"1.5rem"}>
        <Link>{page.page.name}</Link>
      </Typography>
      {page.page.subpages.map((subpage: any, index: number) => (
        <Typography key={index} marginTop={1.7} fontSize={13}>
          <Link href={process.env.REACT_APP_WORDPRESS_URL + subpage.page.href}>{subpage.page.name}</Link>
        </Typography>
      ))}
    </Box>
  );
};

export default Footerlinks;
